import { render, staticRenderFns } from "./VitalSigns.vue?vue&type=template&id=cb4124b0&scoped=true"
import script from "./VitalSigns.vue?vue&type=script&lang=js"
export * from "./VitalSigns.vue?vue&type=script&lang=js"
import style0 from "./VitalSigns.vue?vue&type=style&index=0&id=cb4124b0&prod&scoped=true&lang=css"
import style1 from "./VitalSigns.vue?vue&type=style&index=1&id=cb4124b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4124b0",
  null
  
)

export default component.exports